var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScholarshipYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 3.9375C2.75 3.5578 3.0578 3.25 3.4375 3.25H4.8125C5.1922 3.25 5.5 3.5578 5.5 3.9375V5.3125C5.5 5.6922 5.1922 6 4.8125 6H3.4375C3.0578 6 2.75 5.6922 2.75 5.3125V3.9375Z",
    fill: "#E1CE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3.9375C6.875 3.5578 7.1828 3.25 7.5625 3.25H8.9375C9.3172 3.25 9.625 3.5578 9.625 3.9375V5.3125C9.625 5.6922 9.3172 6 8.9375 6H7.5625C7.1828 6 6.875 5.6922 6.875 5.3125V3.9375Z",
    fill: "#E1CE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 3.25C11.3078 3.25 11 3.5578 11 3.9375V5.3125C11 5.6922 11.3078 6 11.6875 6H13.0625C13.4422 6 13.75 5.6922 13.75 5.3125V3.9375C13.75 3.5578 13.4422 3.25 13.0625 3.25H11.6875Z",
    fill: "#E1CE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 8.0625C2.75 7.6828 3.0578 7.375 3.4375 7.375H4.8125C5.1922 7.375 5.5 7.6828 5.5 8.0625V9.4375C5.5 9.8172 5.1922 10.125 4.8125 10.125H3.4375C3.0578 10.125 2.75 9.8172 2.75 9.4375V8.0625Z",
    fill: "#E1CE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 7.375C7.1828 7.375 6.875 7.6828 6.875 8.0625V9.4375C6.875 9.8172 7.1828 10.125 7.5625 10.125H8.9375C9.3172 10.125 9.625 9.8172 9.625 9.4375V8.0625C9.625 7.6828 9.3172 7.375 8.9375 7.375H7.5625Z",
    fill: "#E1CE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.0625C11 7.6828 11.3078 7.375 11.6875 7.375H13.0625C13.4422 7.375 13.75 7.6828 13.75 8.0625V9.4375C13.75 9.8172 13.4422 10.125 13.0625 10.125H11.6875C11.3078 10.125 11 9.8172 11 9.4375V8.0625Z",
    fill: "#E1CE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 11.5C3.0578 11.5 2.75 11.8078 2.75 12.1875V13.5625C2.75 13.9422 3.0578 14.25 3.4375 14.25H4.8125C5.1922 14.25 5.5 13.9422 5.5 13.5625V12.1875C5.5 11.8078 5.1922 11.5 4.8125 11.5H3.4375Z",
    fill: "#E1CE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.1875C6.875 11.8078 7.1828 11.5 7.5625 11.5H8.9375C9.3172 11.5 9.625 11.8078 9.625 12.1875V13.5625C9.625 13.9422 9.3172 14.25 8.9375 14.25H7.5625C7.1828 14.25 6.875 13.9422 6.875 13.5625V12.1875Z",
    fill: "#E1CE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 11.5C11.3078 11.5 11 11.8078 11 12.1875V13.5625C11 13.9422 11.3078 14.25 11.6875 14.25H13.0625C13.4422 14.25 13.75 13.9422 13.75 13.5625V12.1875C13.75 11.8078 13.4422 11.5 13.0625 11.5H11.6875Z",
    fill: "#E1CE00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.875C0 1.11561 0.615608 0.5 1.375 0.5H15.125C15.8844 0.5 16.5 1.11561 16.5 1.875V21.125C16.5 21.8844 15.8844 22.5 15.125 22.5H1.375C0.615609 22.5 0 21.8844 0 21.125V1.875ZM15.125 1.875L1.375 1.875V21.125H5.5V17.6875C5.5 17.3078 5.8078 17 6.1875 17H10.3125C10.6922 17 11 17.3078 11 17.6875V21.125H15.125V1.875Z",
    fill: "#E1CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipYellowIcon);
export default __webpack_public_path__ + "static/media/scholarship-yellow-icon.4ae30d4df4b3d5ef4b47e90bdc59deda.svg";
export { ForwardRef as ReactComponent };